export function useScrollToElement() {
    const scrollToElement = (elementId, offset = 130) => {
        const element = document.getElementById(elementId);
        if (!element) return;

        const {$device} = useNuxtApp();
        const isDesktop = $device?.isDesktop;

        if (isDesktop) {
            // Desktop: use scrollIntoView
            element.scrollIntoView({behavior: 'smooth'});
        } else {
            // Mobile/tablet: manual scroll with offset
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: elementPosition - offset,
                behavior: 'smooth',
            });
        }
    };

    return {
        scrollToElement,
    };
}
  